import {isDevelopment} from "./utils";

function getAmpKey() {
  if (isDevelopment()) return 'a112a3a9f1d7bc8b0748ab5aff5d6293'
  else return 'fa125c7b76233349c03965d5609d515c'
}

// Init Amplitude
export function init() {
  const amplitude = require("amplitude-js");
  window.amplitude = amplitude
  amplitude.getInstance()?.init(getAmpKey(), null, {
    includeUtm: true,
    includeReferrer: true,
  });
  // document.body.addEventListener('click', event => {
  //     let el = event.target
  //     log('Click',{text: el.innerText, id:el.id, value: el.value, tag: el.tagName, class: el.classList})
  // })
}

function getAmplitude() {
  if (!window.amplitude) {
    init()
  }

  return window.amplitude;
}

// Log Events
export function log(event, properties) {
  if (!event) return
  getAmplitude()?.getInstance().logEvent(event, {
    ...properties,
    navigator: {
      appVersion: window.navigator?.appVersion,
      connection: window.navigator?.connection,
      platform: window.navigator?.platform,
      userAgent: window.navigator?.userAgent,
    }
  });
}


export function logPageView(properties = {}) {
  log(EVENTS.PAGE_VIEW, {
    page: window.location.pathname,
    ...properties
  })
}

export const EVENTS = {
  PAGE_VIEW: 'Page View',
  LOGIN: 'Login in',
  REGISTER: 'Register',
}

// Identify a user
export function identify(userId) {
  if (!userId) return
  if (typeof userId === 'string') userId = userId.toLowerCase()
  getAmplitude()?.getInstance()?.setUserId(userId)
}